module.exports = __webpack_public_path__ + "img/hypatiaediciones.0f6c2c95.png";